var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 3.33398C17.5447 3.33398 18.2645 4.01388 18.3281 4.87627L18.3327 5.00065V15.0007C18.3327 15.8793 17.6528 16.5991 16.7904 16.6627L16.666 16.6673H3.33268C2.45405 16.6673 1.73421 15.9874 1.67059 15.125L1.66602 15.0007V5.00065C1.66602 4.12202 2.34591 3.40218 3.2083 3.33856L3.33268 3.33398H16.666ZM16.666 6.17918L10.8832 11.962C10.395 12.4502 9.6036 12.4502 9.11543 11.962L3.33268 6.17918V15.0007H16.666V6.17918ZM15.4875 5.00065H4.51109L9.99935 10.4889L15.4875 5.00065Z",
    fill: "#292B2E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.d3a127c5ae01e43372d70bcef9126fda.svg";
export { ForwardRef as ReactComponent };